import { GET_COUNTRY_STATE_CITY } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_COUNTRY_STATE_CITY:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getCountryStateCity.js